import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { CreateMalwareRevisionReportRequest } from '../../../../shared/types/routes/internalTools/malwareReport';

function createMalwareReport(malwareData: CreateMalwareRevisionReportRequest): Promise<Response> {
  return post<CreateMalwareRevisionReportRequest, void>('/api/internal-tools/malware', malwareData);
}

/**
 * Hook to create a new malware report
 */
export default function useCreateMalwareReport() {
  return useToastedMutation({
    mutationFn: createMalwareReport,
    successToastMessage: 'Malware report created successfully',
    errorToastMessage: 'Failed to create malware report.',
    onSuccess: () => {
      // Invalidate and refetch malware reports
      queryClient.invalidateQueries({ queryKey: ['malware'] });
    },
  });
}
